export default __webpack_public_path__ + "static/media/videoProduct.2b1a5b7b.mp4";